import { useMemo } from "react";
import { useDeviceInfoQuery } from "@/hooks";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function OnlyAndroid(_ref) {
  let {
    version,
    children
  } = _ref;
  const {
    data
  } = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  });
  const deviceInfo = data === null || data === void 0 ? void 0 : data.deviceInfo;
  const isAndroid = useMemo(() => {
    if (deviceInfo) {
      if (version) {
        return deviceInfo.isAndroid && deviceInfo.os.major <= version;
      } else {
        return deviceInfo.isAndroid;
      }
    }
    return false;
  }, [deviceInfo]);
  if (!isAndroid) return null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}